<template>
  <div>
    <section>
      <TippCard
        hintID="Diensterfassung_Konfiguration_Genehmigungsprozess_1_V1"
        text="Dokumentierte Dienstberichte unterliegen einem frei konfigurierbaren Genehmigungsprozess."
      >
      </TippCard>
    </section>
    <v-snackbar v-model="helpers.snackbar.model" timeout="5000"
      >{{ helpers.snackbar.text }}.</v-snackbar
    >
    <section>
      <template>
        <v-container>
          <v-row>
            <v-col cols="12">
              <Subheader
                icon="mdi-check-decagram"
                title="Genehmigungsprozess (Standard)"
                :actions="actions"
              ></Subheader>
              <div class="mt-7">
                <approval-process-editor
                  v-model="dutyManagementConfig.approvalProcess.default"
                ></approval-process-editor>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";
import ApprovalProcessEditor from "@/components/processes/ApprovalProcessEditor.vue";
// import { DUTY_MANAGEMENT_CONFIG_REPORT_TYPES_create } from "@/data/permission-types.js";

export default {
  name: "duty-management-config-tab-approval-process",
  components: {
    TippCard,
    Subheader,
    ApprovalProcessEditor,
    // CustomDialog,
  },
  data() {
    return {
      helpers: {
        snackbar: { model: false, text: "" },
      },
    };
  },
  computed: {
    dutyManagementConfig() {
      return this.$store.state.organization.activeOrganization.config
        .dutyManagement;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {},
  },
};
</script>
